import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  DestroyRef,
  inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { SiteSearchListComponent } from '../site-search-list/site-search-list.component';
import { SiteModel } from '@app/core/models/site.model';
import { takeUntil } from 'rxjs/operators';
import { SearchMode } from '../../models/site-search-mode.model';
import { SiteSearchInputModel } from '../../models/site-search-input.model';

@Component({
    selector: 'app-site-search',
    templateUrl: './site-search.component.html',
    styleUrls: ['./site-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SiteSearchComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  @Input() site: SiteModel;
  @Input() searchMode: SearchMode = 'site';
  @Output() siteSelected = new EventEmitter<SiteModel>();

  isByLocation: boolean;

  constructor(
    private _bottomSheet: MatBottomSheet,
    private _cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  openSiteSearchText() {
    this.openSiteSearch(false);
  }

  openSiteSearchLocation() {
    this.openSiteSearch(true);
  }

  private openSiteSearch(byLocation = false) {

    const siteSearch = this._bottomSheet.open(SiteSearchListComponent, {
      data: {
        byLocation,
        searchMode: this.searchMode,
        // set current site as default search term
        searchTerm: (!byLocation && this.site) ? this.site.name : null
      } as SiteSearchInputModel,
      panelClass: 'site-search-list-bottom-sheet-container',
    });

    // set output
    siteSearch.instance.selection.asObservable()
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        takeUntil(siteSearch.afterDismissed())
      )
      .subscribe((siteSelection) => {
        this.site = siteSelection.site;
        this.isByLocation = siteSelection.byLocation;
        this.siteSelected.emit(siteSelection.site);
        this._cd.detectChanges();
      });
  }
}
